import React from "react";
import InfoIcon from "components/common/Svg/Info";
/**
 * @param {Object} props
 * @param {string} props.className
 * @param {boolean} props.isVisible
 * @param {string} props.title
 * @param {React.ReactChild || string} props.message
 */
export const CreditMonitoringErrorBox = (props) => {
  const { className, isVisible, title, message } = props;
  if (!isVisible) {
    return null;
  }
  return (
    <div className={`flex flex-col items-start py-4 px-6 bg-red-100 rounded ${className}`}>
      <div className="flex items-center">
        <InfoIcon color="red" className="mr-1" />
        <p className="text-base font-bold ml-2">{title}</p>
      </div>
      <p className="mt-2 ml-6">
        {message}
      </p>
    </div>
  );
};
